const PRODUCE_PURCHASE_ORDERS_PATH = "/produce/purchasing/orders";
const FULFILL_PURCHASE_ORDERS_PATH = "/fulfill/purchasing/orders";

const resolvePurchaseOrdersPath = (pathname: string): string =>
	pathname.startsWith("/fulfill/") ? FULFILL_PURCHASE_ORDERS_PATH : PRODUCE_PURCHASE_ORDERS_PATH;

const purchaseOrderRoutes = {
	resolvePurchaseOrdersPath,
	FULFILL_PURCHASE_ORDERS_PATH,
	PRODUCE_PURCHASE_ORDERS_PATH
} as const;

export default purchaseOrderRoutes;
